import { useTranslation } from 'react-i18next';

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  DescriptionList,
} from '@shared/ui';

export function DescriptionListShowcase() {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('uiLibrary.dataDisplay.descriptionList.title')}</CardTitle>
        <CardDescription>{t('uiLibrary.dataDisplay.descriptionList.description')}</CardDescription>
      </CardHeader>
      <CardContent>
        <DescriptionList
          columns={1}
          items={[
            {
              id: 'name',
              term: t('uiLibrary.dataDisplay.descriptionList.name'),
              description: 'Avery Fox',
            },
            {
              id: 'email',
              term: t('uiLibrary.dataDisplay.descriptionList.email'),
              description: 'avery@example.com',
            },
          ]}
        />
      </CardContent>
    </Card>
  );
}
